import { commonUtils } from './common_utils';
import { counters } from './counters';
import './dealer_list_search';
import { compareAd } from './compare_ad';
import { favouriteAd } from './favourite_ad';
import './native_share';
import { adCampaign } from './ad_campaign';
import { sellerInboxConversation } from './ad_contact_request';

// Safely parse HTML error messages to extract links (prevents XSS)
const renderSafeError = (msg) => {
    if (!msg) return '';
    const text = typeof msg === 'object' ? msg.message || '' : String(msg);
    if (!text.includes('<a')) return text; // Plain text

    // Parse HTML safely using DOMParser
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    const link = doc.querySelector('a');

    if (link) {
        try {
            // Validate URL scheme to prevent javascript: XSS
            const parsedUrl = new URL(link.href, globalThis.location.href);
            if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
                return { url: link.href, text: link.textContent };
            }
            // Unsafe scheme (javascript:, data:, etc.) - return plain text only
            return link.textContent || text;
        } catch {
            // Invalid/malformed URL - return plain text only
            return link.textContent || text;
        }
    }

    return text;
};

const adDetail = {
    init() {
        let $body = $('body');
        $body.on('click', '.showHideTechnicalSection', function (e) {
            if ($(e.target).hasClass('vehicle-all-info__mobile-title') || $(e.target).hasClass('expandGradeSection')) {
                $(this).toggleClass('vehicle-all-info__mobile-details_opened');
            }
        });

        $body.on('click', '.showHideSellerInfoSection', function (_e) {
            $(this).parent('.seller-information-card').toggleClass('seller-information-card-opened');
        });

        $body.on('click touch', '.showHideWarrantySection', function () {
            $(this).parent().toggleClass('warranty-section__mobile-details_opened');
        });

        $body.on('click touch keydown', '.phoneCallWrap', function () {
            $(this).find('.phone_call_tooltip').show();
        });

        $body.on('click touch', function (event) {
            if (
                !(
                    $(event.target).hasClass('phoneCallWrap') ||
                    $(event.target).parent().hasClass('phoneCallWrap') ||
                    $(event.target).hasClass('tooltip_close_btn')
                )
            ) {
                if ($(this).find('.phone_call_tooltip').is(':visible')) {
                    $('.phone_call_tooltip').hide();
                }
            }
            if ($(event.target).hasClass('tooltip_close_btn')) {
                $(event.target).parent().hide();
            }
        });

        commonUtils.dataLayer.productDetailView();
    },
};

const commonAdDetail = {
    showNote() {
        $('#noteSection').addClass('read-full-note');
    },
    hideNote() {
        $('#noteSection').removeClass('read-full-note');
    },
    hideAdSliderTab() {
        $('.viewAdTabsContent').each(function () {
            if (!$(this).hasClass('details-page-view-history__content_active')) {
                $(this).hide();
            }
        });
    },
    showStickyHeader() {
        let shareBox = $('#share_box_new');
        let detailsToolbar = $('.details-tool-bar');
        // Show sticky bar on large screen only, for it check "details-tool-bar" element is visible
        if (
            detailsToolbar.is(':visible') &&
            $(globalThis).scrollTop() > detailsToolbar.position().top + detailsToolbar.height()
        ) {
            shareBox.slideDown(300);
        } else {
            shareBox.hide();
        }
    },
    showPreviousNextLinks() {
        let shareBox = $('#share_box_new');
        let arrowPosition = shareBox.length ? shareBox.offset().top + shareBox.outerHeight() : 0;
        if (navigator.userAgent.match(/iPad/i)) {
            arrowPosition -= 150;
        } else if (navigator.userAgent.match(/iPhone/i)) {
            arrowPosition -= 300;
        }

        if ($(globalThis).scrollTop() + $(globalThis).height() > arrowPosition) {
            let gotoLinks = $('.goto-previous-next-vif');
            gotoLinks.fadeIn(250);
            gotoLinks.css('visibility', 'visible');
        }
    },
    isElementInViewport(element) {
        let elementTop = element.offset().top;
        let elementBottom = elementTop + element.outerHeight();
        let viewportTop = $(globalThis).scrollTop();
        let viewportBottom = viewportTop + $(globalThis).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    },
    showStickyContactBar() {
        let stickyContactBar = $('#stickyContactBar');
        let contactDetail = $('#contactDetail');
        let bigImageSlider = $('#big_img_slider');
        let adDetailSlider = $('#adDetailSlider');
        let scrollTop = $(globalThis).scrollTop();

        if (contactDetail.is(':visible') && scrollTop > bigImageSlider.height() - contactDetail.height()) {
            let adSliderPosition = adDetailSlider.length ? adDetailSlider.position() : null;
            let adSliderBottom = adSliderPosition ? adSliderPosition.top - adDetailSlider.height() : 0;
            if (scrollTop < adSliderBottom) {
                stickyContactBar.show();
            } else {
                stickyContactBar.hide();
            }
        }
    },
    showSimilarLinkDetail() {
        let adId = $('#similarAdLinkElement').data('ad-id');
        if (adId) {
            $.get(Routing.generate('ad_detail_similar_ad_detail'), { adId }, function (response) {
                if (response.success) {
                    const { similar_ad_param, similar_ad_link, similar_ad_count } = response;
                    const targetElements = $('.similarAdLink, .similarAdLinkMobile, .similarAdLinkSticky');

                    targetElements.attr({
                        'data-similar-ad-param': JSON.stringify(similar_ad_param),
                        'data-similar-ad-link': similar_ad_link,
                    });

                    const countText = `(${similar_ad_count})`;
                    $('.similarAdLink span, .similarAdLinkMobile span').text(countText);
                    $('.similarAdLinkSticky span').text(similar_ad_count);
                }
            });
        }
    },
    handleFavouriteFromVif($favouriteButton) {
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init('tag_favorite_topbar');
            return;
        }

        let elementName = 'sub-header-mobile__show-favorites';
        if ($favouriteButton.hasClass('page-features__show-favorites')) {
            elementName = 'page-features__show-favorites';
        }

        favouriteAd.init({
            pageName: 'viewAd',
            adId: $favouriteButton.data('ad-id'),
            element: $(`.${elementName}`),
            selectedClassName: $favouriteButton.hasClass('page-features__show-favorites')
                ? 'showFavouriteOpen page-features__show-favorites_open'
                : 'sub-header-mobile__show-favorites_open',
        });

        if (
            $favouriteButton.hasClass('page-features__show-favorites_open') ||
            $favouriteButton.hasClass('sub-header-mobile__show-favorites_open') ||
            $favouriteButton.hasClass('item-fav-added')
        ) {
            if (favouriteAd.remove()) {
                $('.addToFavouriteFromVifSticky').html(Translations.add_to_favourite);
                $('.addTofavouriteFromVifImage')
                    .removeClass('item-fav-added')
                    .prop('title', Translations.add_to_favourite);

                if ($('.addToCompareFromVifImage').length === 0) {
                    $('.addTofavouriteFromVifImage').addClass('none-imp');
                }
            }
        } else {
            favouriteAd.add();
            $('.addToFavouriteFromVifSticky').html(Translations.remove_from_favourite);
            $('.addTofavouriteFromVifImage')
                .addClass('item-fav-added')
                .prop('title', Translations.remove_from_favourite);
        }
    },
    async handleCompareFromVif($compareButton) {
        let selectedClassName = 'sub-header-mobile__show-compare';
        if ($compareButton.hasClass('page-features__show-compare')) {
            selectedClassName = 'page-features__show-compare';
        }

        compareAd.init({
            pageName: 'viewAd',
            elementToAddSelectedClass: $(`.${selectedClassName}`),
            selectedClassName: $compareButton.hasClass('page-features__show-compare')
                ? 'page-features__show-compare_open'
                : 'sub-header-mobile__show-compare_open',
        });

        if (
            $compareButton.hasClass('page-features__show-compare_open') ||
            $compareButton.hasClass('sub-header-mobile__show-compare_open') ||
            $compareButton.hasClass('showCompareOpen')
        ) {
            compareAd.openCompareModal();
        } else {
            let isCompareAdPushed = await compareAd.add($compareButton.data('ad-id'));
            if (isCompareAdPushed) {
                $('.addToCompareFromVif').html(Translations.added_to_compare_single_line);
                $('.addToCompareFromVifSticky').html(Translations.added_to_compare_single_line);
                $('.addToCompareFromVifImage')
                    .addClass('item-compare-added')
                    .prop('title', Translations.added_to_compare_single_line);
                compareAd.openCompareModal();
            }
        }
    },
};

const reportBadAd = {
    url: Routing.generate('ajax_submit_report'),
    validate(isReported, isAdOwner, title) {
        if (isReported || isAdOwner) {
            alert(title);
        } else {
            globalThis.$.colorbox({
                inline: true,
                href: '#badAd_vif_new',
                onLoad() {
                    $('html').css({ overflow: '' });
                },
            });
        }
    },
    send() {
        $('#badAdError').html('').hide();
        $('#badAdSubmit').prop('disabled', true);
        let params = $('#badAd').serialize();
        $.post(this.url, params, function (response) {
            $('#badAdSubmit').prop('disabled', false);
            if (response.success) {
                let badAdSpace = $('.bad_ad_space');
                badAdSpace.data('is-reported', 1);
                badAdSpace.data('bad-ad-title', Translations.ad_detail.print_stats.dont_report_twice);
                globalThis.$.colorbox.close();
                commonUtils.showNotification(response.message);
            } else {
                const $error = $('#badAdError');
                const parsed = renderSafeError(response.message);
                if (parsed.url) {
                    $error.empty().append($('<a>').attr('href', parsed.url).text(parsed.text));
                } else {
                    $error.text(parsed);
                }
                $error.show();
                globalThis.$.colorbox.resize();
            }
        });
        return false;
    },
};

const smartSaleOffer = {
    currentConversationUuid: null,
    currentConversationData: null,

    openModal(modalType) {
        const modalSelector = `#${modalType}`;
        if ($(modalSelector).length > 0) {
            globalThis.$.colorbox({
                inline: true,
                href: modalSelector,
                onLoad() {
                    if (commonUtils.isMobileView()) {
                        $('html').css({ overflow: '' });
                    }
                    smartSaleOffer.initializeFormHandlers();
                },
            });
        } else {
            globalThis.$.colorbox({
                inline: true,
                href: '#basicAd',
                onLoad() {
                    if (commonUtils.isMobileView()) {
                        $('html').css({ overflow: '' });
                    }
                    smartSaleOffer.initializeFormHandlers();
                },
            });
        }
    },

    initializeFormHandlers() {
        $('#basicOfferForm, #verifiedOfferForm').off('submit.smartOffer');
        $('.smart-sell-modal .cancel').off('click.smartOffer');
        $('#existingOffer button[type="submit"]').off('click.smartOffer');

        $('#basicOfferForm').on('submit.smartOffer', function (e) {
            e.preventDefault();
            smartSaleOffer.submitOffer(this, 'basic');
        });

        $('#verifiedOfferForm').on('submit.smartOffer', function (e) {
            e.preventDefault();
            smartSaleOffer.submitOffer(this, 'verified');
        });

        $('#existingOffer button[type="submit"]').on('click.smartOffer', function (e) {
            e.preventDefault();
            smartSaleOffer.goToExistingConversation();
        });

        $('.smart-sell-modal .cancel').on('click.smartOffer', function () {
            globalThis.$.colorbox.close();
        });
    },

    submitOffer(form, offerType) {
        const $form = $(form);
        const $submitButton = $form.find('button[type="submit"]');
        const $errorContainer = $form.find('.offer-error-message');

        $errorContainer.hide().empty();

        const offerPrice = $form.find('input[name="offerPrice"]').val();
        const offerDescription = $form.find('textarea[name="offerDescription"]').val() || '';
        const token = $form.find('input[name="token"]').val();
        const subjectId = $form.find('input[name="subjectId"]').val();
        const message = $submitButton.data('message') || '';
        const conversationUuid =
            $submitButton.data('conversation-uuid') || smartSaleOffer.currentConversationUuid || '';

        if (
            !offerPrice ||
            Number.isNaN(offerPrice) ||
            Number.parseInt(offerPrice, 10) < 1 ||
            Number.parseInt(offerPrice, 10) > 999999
        ) {
            $errorContainer.text(Translations.inbox.invalid_price).show();
            return;
        }

        $submitButton.prop('disabled', true);
        const formData = {
            token,
            subjectId: Number.parseInt(subjectId, 10),
            offerPrice: Number.parseInt(offerPrice, 10),
            offerDescription,
            offerType,
            message,
        };

        if (conversationUuid) {
            formData.conversationUuid = conversationUuid;
        }

        $.ajax({
            url: Routing.generate('inbox_submit_offer'),
            type: 'POST',
            data: formData,
            dataType: 'json',
        })
            .done(function (response) {
                if (response.success && (response.conversationUrl || response.conversationUuid)) {
                    const inboxUrl = $(`#${offerType}Ad button[type="submit"]`).data('inbox-url');
                    globalThis.location.href = `${inboxUrl}/keskustelu/${response.conversationUuid}`;
                } else {
                    const errorMsg = response.error || Translations.inbox.offer_failed;
                    const parsed = renderSafeError(errorMsg);
                    if (parsed.url) {
                        $errorContainer.empty().append($('<a>').attr('href', parsed.url).text(parsed.text));
                    } else {
                        $errorContainer.text(parsed);
                    }
                    $errorContainer.show();
                    $submitButton.prop('disabled', false);
                }
            })
            .fail(function (xhr) {
                let errorMsg = Translations.inbox.offer_failed;

                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMsg = xhr.responseJSON.error;
                }

                const parsed = renderSafeError(errorMsg);
                if (parsed.url) {
                    $errorContainer.empty().append($('<a>').attr('href', parsed.url).text(parsed.text));
                } else {
                    $errorContainer.text(parsed);
                }
                $errorContainer.show();
                $submitButton.prop('disabled', false);
            });
    },

    goToExistingConversation() {
        const inboxUrl = $('#existingOffer button[type="submit"]').data('inbox-url');
        globalThis.$.colorbox.close();
        globalThis.location.href =
            inboxUrl +
            (smartSaleOffer.currentConversationUuid ? `/keskustelu/${smartSaleOffer.currentConversationUuid}` : '');
    },
};

const userContact = {
    isDisplayModal: true,
    getUrl(name) {
        return Routing.generate('text_to_image', { textToConvert: name, fontSize: 52 });
    },
    showPhoneModal(layerId, isDealerPerson) {
        const dealerPerson = isDealerPerson || 'N';
        let idName = `#${layerId}`;
        let adId = $(idName).data('ad-id');
        let postedBy = $(idName).data('posted-by');
        let phone = $(idName).data('phone');
        let mobile = $(idName).data('mobile');
        let city = $(idName).data('city') ? `, ${$(idName).data('city')}` : '';

        counters.adDetailCallCount(adId, postedBy);

        $('#userName, #userCompany').text('');

        if ('Y' === dealerPerson) {
            $('#callMessage').css('display', 'inline');
            $('#userName').text($(idName).data('name'));
            $('#userCompany').text($(idName).data('company') + city);
        } else {
            $('#callMessage').css('display', 'block');
            $('#userName').text($(idName).data('name') + city);
            $('#userCompany').text($(idName).data('company'));
        }

        let mobileNumber = $('#mobileNumber');
        let phoneNumber = $('#phoneNumber');
        if (mobile) {
            $('#userMobile').attr('src', this.getUrl(mobile));
            mobileNumber.css('visibility', 'hidden');
            mobileNumber.show();
        } else {
            mobileNumber.hide();
        }

        if (phone) {
            $('#userPhone').attr('src', this.getUrl(phone));
            phoneNumber.css('visibility', 'hidden');
            phoneNumber.show();
        } else {
            phoneNumber.hide();
        }

        globalThis.$.colorbox({
            inline: true,
            scrolling: false,
            href: '#phoneModal',
            onComplete() {
                if (userContact.isDisplayModal) {
                    userContact.isDisplayModal = false;
                }
                $('#mobileNumber,#phoneNumber').css('visibility', 'visible');
            },
        });

        commonUtils.dataLayer.genericDataLayerEvent('showPhoneNumber');
    },
};

$(function () {
    let $body = $('body');
    adDetail.init();

    $('.deliveryTooltip, .warrantyTooltip').click(function () {
        const tooltipId = `${$(this).data('tooltip-name')}TooltipId`;
        const $currentTooltip = $(`#${tooltipId}`);
        // Hide all tooltips other than the current one
        $('.badge-with-info__tooltip').not($currentTooltip).hide();
        // Toggle the current tooltip visibility
        $currentTooltip.toggle();
    });

    $('.vinInfoIcon').click(function () {
        $(this).next('.vinInfoIconToolTip').toggle(); // Toggle the next sibling (tooltip)
    });

    $('#readMoreCaption').click(function () {
        commonAdDetail.showNote();
    });

    $('#readLessCaption').click(function () {
        commonAdDetail.hideNote();
    });

    $('.bad_ad_space').click(function () {
        reportBadAd.validate($(this).data('is-reported'), $(this).data('is-ad-owner'), $(this).data('bad-ad-title'));
    });

    $('.badAdTabs').click(function () {
        let dataType = $(this).data('type');
        $('.tabContent').hide();
        $(`.${dataType}`).show();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        globalThis.$.colorbox.resize();
    });

    $('#badAd input:radio').click(function () {
        $('#badAd #badAdDescription').prop('disabled', false);
    });

    $('#badAd').on('submit', function (e) {
        e.preventDefault();
        reportBadAd.send();
    });

    $('.googleMapConsentMessage').click(function () {
        // Use `window.` because data is set after page load
        if (!globalThis.$('#cmp_consent').data('google-map')) {
            commonUtils.showConsentMessage();
            return false;
        }

        let address = $(this).data('map-address');
        globalThis.$.colorbox({
            inline: true,
            href: '#bubble_map',
            onComplete() {
                commonUtils.loadEmbedMap(address, 'map_canvas', 300, 304);
            },
        });

        return undefined;
    });

    // Seller VIF ad Show number from sticky footer bar & contact modal.
    $('#showUserNumber, #showUserMobileNumber, #showUserPhoneNumber').click(function () {
        $(this).find('span').text($(this).data('phone'));
    });

    $('button[id^=contactPhoneButton_]').click(function () {
        userContact.showPhoneModal(this.id);
    });

    $('button[id^=userContactLink_]').click(function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }
        userContact.showPhoneModal(this.id);
    });

    $('span[id^=dealerPersonContactLink_]').click(function () {
        userContact.showPhoneModal(this.id, 'Y');
    });

    $('a[id^=dealerPersonEmail_]').click(function () {
        $.ajax({
            type: 'GET',
            url: Routing.generate('update_email_counter'),
            data: `dealerId=${$(this).data('dealer-id')}`,
        });
    });

    $('a[id^=dealerWebsiteLink]').click(function () {
        counters.incrementByAdId('dealer-website', $(this).data('ad-id'));
        $.ajax({
            type: 'GET',
            url: Routing.generate('update_dealer_site_counter'),
            data: `dealerId=${$(this).data('dealer-id')}`,
        });
    });

    $('.whatsappClick').click(function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }

        counters.incrementByAdId('whatsapp-message-mobile', $(this).data('ad-id'));
    });

    $('button[id^=dealerPersonShow]').click(function () {
        commonUtils.showHideToggle('showPersonLess');
        commonUtils.showHideToggle('showPersonMore');
    });

    $('.adBillOfSaleEvent').click(function () {
        commonUtils.dataLayer.genericDataLayerEvent($(this).data('event-name'));
    });

    // for open contact modal for verified and non verified seller ad
    $('.verifiedContactButton').click(function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }
        globalThis.$.colorbox({
            inline: true,
            href: '#contactOrSalesProcessButton',
            onLoad() {
                if (commonUtils.isMobileView()) {
                    $('html').css({ overflow: '' });
                }
            },
        });
    });

    // for open info modal for verified ad
    $('.verifiedInfoIcon').click(function () {
        globalThis.$.colorbox({
            inline: true,
            href: '#infoModal',
            onLoad() {
                if (commonUtils.isMobileView()) {
                    $('html').css({ overflow: '' });
                }
            },
        });
    });

    // for open info modal apply for finance
    $('.verifiedInfoIcon2').click(function () {
        window.$.colorbox({
            inline: true,
            href: '#apply-for-fin-infoModal',
            onLoad() {
                if (commonUtils.isMobileView()) {
                    $('html').css({ overflow: '' });
                }
            },
        });
    });

    setTimeout(function () {
        commonAdDetail.hideAdSliderTab();
        $('#detailsPageViewHistoryTabContent').removeClass('details-page-view-history__tab-content');
    }, 1500);

    $body.on('click', '.viewAdTabs', function () {
        let dataId = $(this).data('id');
        let dataCookieName = $(this).parent('li').parent('ul').data('cookie-name');
        $('.viewAdTabs').removeClass('details-page-view-history__tab-active');
        $(`a[data-id="${dataId}"]`).addClass('details-page-view-history__tab-active');
        $('.viewAdTabsContent').removeClass('details-page-view-history__content_active');
        $(`#${dataId}`).addClass('details-page-view-history__content_active');
        commonAdDetail.hideAdSliderTab();
        commonUtils.setCookie(dataCookieName, dataId, 365 * 24 * 60);
    });

    $body.on('click', '.openLoginPopup', function () {
        globalThis.location.hash = '#show_contact';
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init($(this).data('source'));
            return false;
        }

        return undefined;
    });

    $body.on('click', '.similarAdLinkSticky, .similarAdLinkHashGenerate', function () {
        const similarAdParam = $(this).data('similar-ad-param');
        const similarAdUrl = $(this).data('similar-ad-link');

        $.ajax({
            url: Routing.generate('generate_search_hash'),
            type: 'POST',
            data: similarAdParam,
            timeout: 10000, // 10 second timeout
            success(response) {
                if (response && response.searchHash) {
                    const similarUrl = `${similarAdUrl}?haku=${response.searchHash}`;
                    globalThis.location.href = similarUrl;
                } else {
                    globalThis.location.href = similarAdUrl;
                }
            },
        });
    });

    // On click Facebook share from Share ad
    $body.on('click', '.page-features__share_drop-down__fb', function () {
        counters.incrementByType('vif-facebook-mobile');
        commonUtils.dataLayer.shareButtonDataLayerEvent('Facebook');
    });

    // On click Twitter share from Share ad
    $body.on('click', '.page-features__share_drop-down__twitter', function () {
        commonUtils.openNewWindow($(this).data('twitter-share-url'), 660, 430, '', 250, 200);
        counters.incrementByType('vif-twitter-mobile');
        commonUtils.dataLayer.shareButtonDataLayerEvent('Twitter');
    });

    // On click Whatsapp share from Share ad
    $body.on('click', '.page-features__share_drop-down__whatsapp', function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }
        counters.incrementByType('vif-whatsapp-mobile');
        commonUtils.dataLayer.shareButtonDataLayerEvent('Whatsapp');
    });

    // On click Send to friend from Share ad
    $body.on('click', '.shareLinkByEmail', function () {
        commonUtils.dataLayer.shareButtonDataLayerEvent('Tell a Friend');
    });

    // On click anchor tag from note section except Read more
    $body.on('click', '#noteSection a:not("#readWholeNote")', function () {
        counters.incrementByAdId('vif-note-link', $('#adDetailPage').data('ad-id'));
    });

    // Add/Remove favourite from vif image icon click
    $body.on('click keyup', '.addTofavouriteFromVifImage', function (e) {
        if (e.type === 'click' || (e.type === 'keyup' && e.key === 'Enter')) {
            const shouldContinue = commonUtils.handleZarazEvent($(this));
            if (!shouldContinue) {
                return;
            }
            commonAdDetail.handleFavouriteFromVif($('.addToFavouriteFromVif:first'));
        }
    });

    // Add/Remove compare from vif image icon click
    $body.on('click keyup', '.addToCompareFromVifImage', async function (e) {
        if (e.type === 'click' || (e.type === 'keyup' && e.key === 'Enter')) {
            const shouldContinue = commonUtils.handleZarazEvent($(this));
            if (!shouldContinue) {
                return;
            }
            await commonAdDetail.handleCompareFromVif($('.addToCompareFromVif:first'));
        }
    });

    // Add/Remove ad from VIF
    $body.on('click', '.addToFavouriteFromVif', function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }
        commonAdDetail.handleFavouriteFromVif($(this));
    });

    // Add to compare ad list
    $body.on('click', '.addToCompareFromVif', async function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }
        await commonAdDetail.handleCompareFromVif($(this));
    });

    // Datalayer event when "Check information" / "Tarkista tiedot" button clicked from VIF
    $('.gtmDataLayerRekkari').on('click', function () {
        const shouldContinue = commonUtils.handleZarazEvent($(this));
        if (!shouldContinue) {
            return;
        }
        commonUtils.dataLayer.genericData({
            event: 'checkItemInfo',
            position: 'rekkari.fi',
        });
    });

    $body.on('click', '.openConversationUrl', function () {
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init('send_offer');
            return false;
        }

        const inboxUrl = $(this).data('inbox-url');
        const isVerified = $(this).data('is-verified');
        const segment = isVerified ? 'tee-tarjous' : 'fiksut-kaupat';
        const params = {
            subjectId: $(this).data('ad-id'),
            message: $(this).data('message'),
            token: $(this).data('token'),
        };
        $.ajax({
            type: 'POST',
            url: Routing.generate('inbox_create_conversation'),
            data: params,
        }).done(function (data) {
            if (data.success) {
                if (segment) {
                    globalThis.location.assign(`${inboxUrl}/keskustelu/${data.conversationUuid}/${segment}`);
                }
            } else {
                if ($('#conversationFormBlock').is(':visible')) {
                    $('.inbox-conversation__warning-msg').show();
                    const $convError = $('#conversationFormError');
                    const parsed = renderSafeError(data.error);
                    if (parsed.url) {
                        $convError.empty().append($('<a>').attr('href', parsed.url).text(parsed.text));
                    } else {
                        $convError.text(parsed);
                    }
                } else {
                    $('#conversationFormBlock').show();
                    sellerInboxConversation.openFrom(data.error);
                }

                if (globalThis.$.colorbox?.element) {
                    globalThis.$.colorbox.close();
                }
            }
            return undefined;
        });
        return undefined;
    });

    $body.on('click', '.smartSaleOffer', function (e) {
        e.preventDefault();
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init('send_offer');
            return false;
        }

        const conversationUuid = $(this).data('conversation-uuid');
        const isVerified = $(this).data('is-verified') === true;

        $.ajax({
            type: 'GET',
            url: Routing.generate('inbox_get_conversation'),
            data: {
                conversationUuid,
                isVerified,
            },
        })
            .done(function (data) {
                if (data.success) {
                    smartSaleOffer.currentConversationUuid = conversationUuid;
                    smartSaleOffer.currentConversationData = data;
                    smartSaleOffer.openModal(data.modalType);
                } else {
                    smartSaleOffer.openModal(isVerified ? 'verifiedAd' : 'basicAd');
                }
            })
            .fail(function () {
                smartSaleOffer.openModal(isVerified ? 'verifiedAd' : 'basicAd');
            });

        return undefined;
    });

    // Show the sticky bar & Previous Next ad links on scroll the page
    $(globalThis).scroll(commonUtils.throttle(200, commonAdDetail.showStickyHeader));
    $(globalThis).scroll(commonUtils.throttle(200, commonAdDetail.showPreviousNextLinks));
    $(globalThis).scroll(commonUtils.throttle(200, commonAdDetail.showStickyContactBar));

    // Show similar link detail
    commonAdDetail.showSimilarLinkDetail();

    // Show ad campaign info
    adCampaign.showAdCampaign();
});
